import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import hasInterface from '../../../../../hasInterface';
import Coordinate from '../Coordinate';
import Double from '../../../../../java/lang/Double';
import Coordinates from '../Coordinates';
import CoordinateSequence from '../CoordinateSequence';
import CoordinateArrays from '../CoordinateArrays';
import Serializable from '../../../../../java/io/Serializable';
import StringBuilder from '../../../../../java/lang/StringBuilder';
var CoordinateArraySequence = /*#__PURE__*/function () {
  function CoordinateArraySequence() {
    _classCallCheck(this, CoordinateArraySequence);
    CoordinateArraySequence.constructor_.apply(this, arguments);
  }
  _createClass(CoordinateArraySequence, [{
    key: "getM",
    value: function getM(index) {
      if (this.hasM()) return this._coordinates[index].getM();else return Double.NaN;
    }
  }, {
    key: "setOrdinate",
    value: function setOrdinate(index, ordinateIndex, value) {
      switch (ordinateIndex) {
        case CoordinateSequence.X:
          this._coordinates[index].x = value;
          break;
        case CoordinateSequence.Y:
          this._coordinates[index].y = value;
          break;
        default:
          this._coordinates[index].setOrdinate(ordinateIndex, value);
      }
    }
  }, {
    key: "getZ",
    value: function getZ(index) {
      if (this.hasZ()) return this._coordinates[index].getZ();else return Double.NaN;
    }
  }, {
    key: "size",
    value: function size() {
      return this._coordinates.length;
    }
  }, {
    key: "getOrdinate",
    value: function getOrdinate(index, ordinateIndex) {
      switch (ordinateIndex) {
        case CoordinateSequence.X:
          return this._coordinates[index].x;
        case CoordinateSequence.Y:
          return this._coordinates[index].y;
        default:
          return this._coordinates[index].getOrdinate(ordinateIndex);
      }
    }
  }, {
    key: "getCoordinate",
    value: function getCoordinate() {
      if (arguments.length === 1) {
        var i = arguments[0];
        return this._coordinates[i];
      } else if (arguments.length === 2) {
        var index = arguments[0],
          coord = arguments[1];
        coord.setCoordinate(this._coordinates[index]);
      }
    }
  }, {
    key: "getCoordinateCopy",
    value: function getCoordinateCopy(i) {
      var copy = this.createCoordinate();
      copy.setCoordinate(this._coordinates[i]);
      return copy;
    }
  }, {
    key: "createCoordinate",
    value: function createCoordinate() {
      return Coordinates.create(this.getDimension(), this.getMeasures());
    }
  }, {
    key: "getDimension",
    value: function getDimension() {
      return this._dimension;
    }
  }, {
    key: "getX",
    value: function getX(index) {
      return this._coordinates[index].x;
    }
  }, {
    key: "getMeasures",
    value: function getMeasures() {
      return this._measures;
    }
  }, {
    key: "expandEnvelope",
    value: function expandEnvelope(env) {
      for (var i = 0; i < this._coordinates.length; i++) env.expandToInclude(this._coordinates[i]);
      return env;
    }
  }, {
    key: "copy",
    value: function copy() {
      var cloneCoordinates = new Array(this.size()).fill(null);
      for (var i = 0; i < this._coordinates.length; i++) {
        var duplicate = this.createCoordinate();
        duplicate.setCoordinate(this._coordinates[i]);
        cloneCoordinates[i] = duplicate;
      }
      return new CoordinateArraySequence(cloneCoordinates, this._dimension, this._measures);
    }
  }, {
    key: "toString",
    value: function toString() {
      if (this._coordinates.length > 0) {
        var strBuilder = new StringBuilder(17 * this._coordinates.length);
        strBuilder.append('(');
        strBuilder.append(this._coordinates[0]);
        for (var i = 1; i < this._coordinates.length; i++) {
          strBuilder.append(', ');
          strBuilder.append(this._coordinates[i]);
        }
        strBuilder.append(')');
        return strBuilder.toString();
      } else {
        return '()';
      }
    }
  }, {
    key: "getY",
    value: function getY(index) {
      return this._coordinates[index].y;
    }
  }, {
    key: "toCoordinateArray",
    value: function toCoordinateArray() {
      return this._coordinates;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [CoordinateSequence, Serializable];
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._dimension = 3;
      this._measures = 0;
      this._coordinates = null;
      if (arguments.length === 1) {
        if (arguments[0] instanceof Array) {
          var coordinates = arguments[0];
          CoordinateArraySequence.constructor_.call(this, coordinates, CoordinateArrays.dimension(coordinates), CoordinateArrays.measures(coordinates));
        } else if (Number.isInteger(arguments[0])) {
          var size = arguments[0];
          this._coordinates = new Array(size).fill(null);
          for (var i = 0; i < size; i++) this._coordinates[i] = new Coordinate();
        } else if (hasInterface(arguments[0], CoordinateSequence)) {
          var coordSeq = arguments[0];
          if (coordSeq === null) {
            this._coordinates = new Array(0).fill(null);
            return null;
          }
          this._dimension = coordSeq.getDimension();
          this._measures = coordSeq.getMeasures();
          this._coordinates = new Array(coordSeq.size()).fill(null);
          for (var _i = 0; _i < this._coordinates.length; _i++) this._coordinates[_i] = coordSeq.getCoordinateCopy(_i);
        }
      } else if (arguments.length === 2) {
        if (arguments[0] instanceof Array && Number.isInteger(arguments[1])) {
          var _coordinates = arguments[0],
            dimension = arguments[1];
          CoordinateArraySequence.constructor_.call(this, _coordinates, dimension, CoordinateArrays.measures(_coordinates));
        } else if (Number.isInteger(arguments[0]) && Number.isInteger(arguments[1])) {
          var _size = arguments[0],
            _dimension = arguments[1];
          this._coordinates = new Array(_size).fill(null);
          this._dimension = _dimension;
          for (var _i2 = 0; _i2 < _size; _i2++) this._coordinates[_i2] = Coordinates.create(_dimension);
        }
      } else if (arguments.length === 3) {
        if (Number.isInteger(arguments[2]) && arguments[0] instanceof Array && Number.isInteger(arguments[1])) {
          var _coordinates2 = arguments[0],
            _dimension2 = arguments[1],
            measures = arguments[2];
          this._dimension = _dimension2;
          this._measures = measures;
          if (_coordinates2 === null) this._coordinates = new Array(0).fill(null);else this._coordinates = _coordinates2;
        } else if (Number.isInteger(arguments[2]) && Number.isInteger(arguments[0]) && Number.isInteger(arguments[1])) {
          var _size2 = arguments[0],
            _dimension3 = arguments[1],
            _measures = arguments[2];
          this._coordinates = new Array(_size2).fill(null);
          this._dimension = _dimension3;
          this._measures = _measures;
          for (var _i3 = 0; _i3 < _size2; _i3++) this._coordinates[_i3] = this.createCoordinate();
        }
      }
    }
  }]);
  return CoordinateArraySequence;
}();
export { CoordinateArraySequence as default };